import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import WizardContent from '~/layouts/WizardContent';
import LeftLayout from '~/layouts/LeftLayout';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import features from '~/constants/features';
import { SubmitStageImg } from '~/img';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import { useProceedStep } from '~/controllers/wizard';
import { proceedTechFailedOnboarding } from '~/api/onboarding';
import AutomatedOnboardingErrors from '~/pages/ksa/completion/components/AutomatedOnboardingErrors';
import CompletionContainer from '~/pages/ksa/completion/components/CompletionContainer';

const TechFailedOnboarding: FC = () => {
  const { t } = useTranslation('ksaCompletion');
  const proceed = useProceedStep(proceedTechFailedOnboarding);

  const onClick = () => {
    proceed.mutateAsync().catch((e) => {
      console.error(`failed to submit; error:`, e);
    });
  };

  return (
    // <WizardContent
    //   content={
    <CompletionContainer>
      <Typography.Title>{t('Automated onboarding failed')}</Typography.Title>
      <Typography.Paragraph className="Completion-Paragraph">
        {t(
          'This application was failed to be registered in back office systems due to connection error. Retry the registration to proceed.'
        )}
      </Typography.Paragraph>
      <AutomatedOnboardingErrors />
      <SubmitStageImg className="Completion-Img" />
    </CompletionContainer>
    //   }
    // />
  );
};

export default TechFailedOnboarding;
